export const listOrigin = [
  { textOrigin: 'Todos', valueOrigin: 'Todos' },
  { textOrigin: 'Hiopos', valueOrigin: '1' },
  { textOrigin: 'HiOffice', valueOrigin: '2' },
  { textOrigin: 'Portal Rest', valueOrigin: '3' },
  { textOrigin: 'Api Pedidos', valueOrigin: '4' },
]
